import React from 'react';

const StatusThird = ({ color = '#222222' }: { color?: string }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
    >
      <path
        fill={color}
        d='M5 22q-2.075 0-3.537-1.463T0 17t1.463-3.537T5 12t3.538 1.463T10 17t-1.463 3.538T5 22m0-2q1.25 0 2.125-.875T8 17t-.875-2.125T5 14t-2.125.875T2 17t.875 2.125T5 20m6-1v-5l-3.2-2.8q-.3-.275-.45-.637T7.2 9.8t.163-.762T7.8 8.4l2.8-2.8q.3-.3.688-.45T12.1 5t.813.15t.687.45l1.9 1.9q.7.7 1.6 1.1T19 9v2q-1.425 0-2.713-.55T14 8.9l-.8-.8l-2.4 2.4l2.2 2.3V19zm4.5-13.5q-.825 0-1.412-.587T13.5 3.5t.588-1.412T15.5 1.5t1.413.588T17.5 3.5t-.587 1.413T15.5 5.5M19 22q-2.075 0-3.537-1.463T14 17t1.463-3.537T19 12t3.538 1.463T24 17t-1.463 3.538T19 22m0-2q1.25 0 2.125-.875T22 17t-.875-2.125T19 14t-2.125.875T16 17t.875 2.125T19 20'
        stroke-width='0.4'
        stroke={color}
      />
    </svg>
  );
};

export default StatusThird;
